<template>
    <svg class="stroke-2 w-4 h-4 text-[#073B5D]" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1_7768)">
        <path d="M9.5 6V9.5H2.5V6H1.5V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V6H9.5ZM6.5 6.335L7.795 5.045L8.5 5.75L6 8.25L3.5 5.75L4.205 5.045L5.5 6.335V1.5H6.5V6.335Z" fill="#073B5D"/>
        </g>
        <defs>
        <clipPath id="clip0_1_7768">
        <rect width="12" height="12" fill="white"/>
        </clipPath>
        </defs>
        </svg>
</template>